<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <label for="txtBudgetistsName"> {{$lang.WorkshopBudget.LabelNameExpert}}:</label>
        <div class="input-group">
          <b-form-input type="text"
                        name="txtEmailBudget"
                        :placeholder="'Digite o nome do Orçamentista'"
                        v-model="form.nameBudget.value"
                        :maxlength="form.nameBudget.maxlength"
                        :required="form.nameBudget.required"
                        :state="form.nameBudget.state"></b-form-input>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <label for="txtEmailBudget"> <small v-show="form.emailBudget.required" class="text-danger"></small> {{$lang.WorkshopBudget.LabelEmail}}:</label>
        <div class="input-group">
          <b-form-input type="text"
                        name="txtEmailBudget"
                        :placeholder="$lang.WorkshopBudget.PlaceholderEnterEmail"
                        v-model="form.emailBudget.value"
                        :maxlength="form.emailBudget.maxlength"
                        :required="form.emailBudget.required"
                        :state="form.emailBudget.state"></b-form-input>
        </div>
      </div>
      <div class="col-md-3">
        <label for="txtCellPhoneBudget"><small v-show="form.cellNumberBudget" class="text-danger"></small> {{$lang.MechanicalWorkshop.LabelCellphone}}:</label>
        <div class="input-group">
          <b-form-input type="text"
                        name="txtCellPhoneBudget"
                        :placeholder="$lang.Common.MobilePhonePlaceholder"
                        v-model="form.cellNumberBudget.value"
                        :maxlength="form.cellNumberBudget.maxlength"
                        :state="form.cellNumberBudget.state"
                        v-mask="['(##) ####-####', '(##) # ####-####']"></b-form-input>
        </div>
      </div>
    </div>
    <div class="card-footer mt-4 mb-4" style="border-left: 1px solid #cfd8dc;border-bottom: 1px solid #cfd8dc;border-right: 1px solid #cfd8dc;border-radius: 4px;">
      <button type="button" class="btn btn-third btn-sm" v-on:click="onSave" v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonSave"><i class="fa fa-check-circle"></i> Adicionar</button>&nbsp;
    </div>
    <Tables ref="tableGrid"
        :columns="[$lang.WorkshopBudget.DataTable.Name,
                    $lang.WorkshopBudget.DataTable.Phone,
                    $lang.Common.DataTable.Status,
                    $lang.Common.DataTable.ActionDate,
                    $lang.Common.DataTable.AccountAction,
                    $lang.Common.DataTable.Actions]"
        v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"      :status="obj.status" v-on:Edit="onEdit(obj)" :value="obj.nameBudget" classCss="text-left" />
        <TableColumn :IsText="true"      :status="obj.status" v-on:Edit="onEdit(obj)" :value="obj.cellNumberBudget"/>
        <TableColumn :IsStatus="true"    :status="obj.status" v-on:Edit="onEdit(obj)" />
        <TableColumn :IsDatetime="true"  :status="obj.status" v-on:Edit="onEdit(obj)" :value="obj.dateUpdate" />
        <TableColumn :IsText="true"      :status="obj.status" v-on:Edit="onEdit(obj)" :value="obj.accountUserNameUpdate" />
        <TableColumn :IsActionsButtons="true" :HasChange="false" v-on:Delete="onDelete(obj)" :status="obj.status" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import MechanicalWorkshopBudget from './mechanicalworkshopbudget.js'
export default MechanicalWorkshopBudget
</script>



// WEBPACK FOOTER //
// src/views/private/configuration/mechanicalworkshop/budget/mechanicalworkshopbudget.vue